import { useDispatch } from "react-redux";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as typeUtils from "../../../abstract/controller/utils/typeUtils";
import {
  handleConditionAliasCreate,
  handleConditionAssignmentCreate,
  handleConditionConstraintCreate,
} from "../../../abstract/redux/slice/structureSlice";
import IconPlusCircled from "../../../themes/icons/IconPlusCircled";
import ConditionPanel from "./ConditionPanel";
import styles from "./Conditions.module.scss";
import ConditionStructure from "./structure/ConditionStructure";
import { ButtonDefault } from "../../ui/buttons/ButtonDefault";

function Conditions({ node, main }) {
  return (
    <>
      <SetAliases node={node} main={main} />
      <SetConstraints node={node} main={main} />
      {main && <SetAssignments node={node} main={main} />}
    </>
  );
}

function SetConstraints({ node, main }) {
  const _dispatch = useDispatch();

  const _type = typeUtils.getTypeConditionConstraint();
  const _constraints = nodeUtils.getConditionsConstraints(node);
  const _siblingNames = _constraints.map((e) => nodeUtils.getName(e));

  const handleConstraint = () => {
    _dispatch(handleConditionConstraintCreate(nodeUtils.getID(node)));
  };

  return (
    <div className={styles["container"]}>
      <div
        className={`${styles["container__header"]} ${
          main ? styles["container__header--global"] : styles["container__header--local"]
        }`}>
        Constraints
      </div>
      <div className={`${styles["container__main"]}`}>
        {_constraints.map((e, index) => (
          <ConditionStructure
            key={nodeUtils.getName(e)}
            node={e}
            nodeParent={node}
            index={index}
            siblingNames={_siblingNames}
            type={_type}
            main={main}
          />
        ))}
      </div>
      <ConditionPanel
        node={null}
        nodeParent={node}
        index={-1}
        siblingNames={_siblingNames}
        type={_type}
      />
      <div className={`${styles["container__options"]}`} id="logic_constraint">
        <div className={`${styles["container__icon"]}`}>
          <IconPlusCircled />
        </div>
        <div className={`${styles["container__action"]}`}>
          <ButtonDefault text={"add constraint"} handler={handleConstraint} wide shadow />
        </div>
      </div>
    </div>
  );
}

function SetAssignments({ node, main }) {
  const _dispatch = useDispatch();

  const _type = typeUtils.getTypeConditionAssignment();
  const _assignments = nodeUtils.getConditionsAssignments(node);
  const _siblingNames = _assignments.map((e) => nodeUtils.getName(e));

  const handleAssignment = () => {
    _dispatch(handleConditionAssignmentCreate(nodeUtils.getID(node)));
  };

  return (
    <div className={styles["container"]}>
      <div
        className={`${styles["container__header"]} ${
          main ? styles["container__header--global"] : styles["container__header--local"]
        }`}>
        Assignments
      </div>
      <div className={`${styles["container__main"]}`}>
        {_assignments.map((e, index) => (
          <ConditionStructure
            key={nodeUtils.getName(e)}
            node={e}
            nodeParent={node}
            index={index}
            siblingNames={_siblingNames}
            type={_type}
            main={main}
          />
        ))}
        <ConditionPanel
          node={null}
          nodeParent={node}
          index={-1}
          siblingNames={_siblingNames}
          type={_type}
        />
      </div>
      <div className={`${styles["container__options"]}`} id="logic_assignment">
        <div className={`${styles["container__icon"]}`}>
          <IconPlusCircled />
        </div>
        <div className={`${styles["container__action"]}`}>
          <ButtonDefault text={"add assignment"} handler={handleAssignment} wide shadow />
        </div>
      </div>
    </div>
  );
}

function SetAliases({ node, main }) {
  const _dispatch = useDispatch();

  const _type = typeUtils.getTypeConditionAlias();
  const _aliases = nodeUtils.getConditionsAliases(node);
  const _siblingNames = _aliases.map((e) => nodeUtils.getName(e));

  const handleAlias = () => {
    _dispatch(handleConditionAliasCreate(nodeUtils.getID(node)));
  };

  return (
    <div className={styles["container"]}>
      <div
        className={`${styles["container__header"]} ${
          main ? styles["container__header--global"] : styles["container__header--local"]
        }`}>
        Aliases
      </div>
      <div className={`${styles["container__main"]}`}>
        {_aliases.map((e, index) => (
          <ConditionStructure
            key={nodeUtils.getName(e)}
            node={e}
            nodeParent={node}
            index={index}
            siblingNames={_siblingNames}
            type={_type}
            main={main}
          />
        ))}
        <ConditionPanel
          node={null}
          nodeParent={node}
          index={-1}
          siblingNames={_siblingNames}
          type={_type}
        />
      </div>
      <div className={`${styles["container__options"]}`} id="logic_alias">
        <div className={`${styles["container__icon"]}`}>
          <IconPlusCircled />
        </div>
        <div className={`${styles["container__action"]}`}>
          <ButtonDefault text={"add alias"} handler={handleAlias} wide shadow />
        </div>
      </div>
    </div>
  );
}

export default Conditions;
